// Modules
import moment from 'moment';
import { useEffect, useState } from 'react';

// Utils
import { DATE_TIME_FORMAT } from '../../common/constants';

// Modals
import { HealthCheckUnhealthyModal } from '../mymessages/modalTemplates/HealthCheckUnhealthyModal';

import { HealthCheckStatusWrapper } from './HealthCheckStatusStyles';
import DraxRenewLogo from '../../assets/images/drax-renew-logo.png';
import HealthCheckStatusHeader from './HealthCheckStatusHeader';
import { HealthCheckStatus } from './HealthCheckStatus';
import healthCheckDataJson from './data/healthCheckData';

export const HealthCheck = () => {
  let currentDateTime = moment().format(DATE_TIME_FORMAT);

  const [showUnhealthyStatusModal, setShowUnhealthyStatusModal] = useState<boolean>(false);
  const [healthyStatusCount, setHealthyStatusCount] = useState<number>(0);
  const [degradedStatusCount, setDegradedStatusCount] = useState<number>(0);
  const [unhealthyStatusCount, setUnhealthyStatusCount] = useState<number>(0);
  const [refreshTime, setRefreshTime] = useState(currentDateTime);
  const [unhealthyDescription, setUnhealthyDescription] = useState<any>([]);

  useEffect(() => {
    setInterval(() => {
      let newTime = moment().format(DATE_TIME_FORMAT);

      setHealthyStatusCount(0);
      setDegradedStatusCount(0);
      setUnhealthyStatusCount(0);

      setRefreshTime(newTime);
    }, 60000 * 30);
  }, []);

  const handleStatusClick = (error: any) => {
    const data = `${error.map((item: any) => `${item.entry} - ${item.error}`).join(',\n')}`;

    setUnhealthyDescription(data);
    setShowUnhealthyStatusModal(true);
  };

  const handleStatusSet = (status: string) => {
    if (status === 'Healthy') {
      setHealthyStatusCount(prevCount => {
        const newCount = prevCount + 1;
        return newCount;
      });
    } else if (status === 'Degraded') {
      setDegradedStatusCount(prevCount => {
        const newCount = prevCount + 1;
        return newCount;
      });
    } else if (status === 'Unhealthy') {
      setUnhealthyStatusCount(prevCount => {
        const newCount = prevCount + 1;
        return newCount;
      });
    }
  };

  return (
    <>
      <HealthCheckStatusWrapper>
        <div className='healthCheckStatusDesktop container-fluid'>
          <img className='pl-2 draxLogo' src={DraxRenewLogo} />
          <div className='d-flex justify-content-center pt-5'>
            <div className='col-md-8'>
              <HealthCheckStatusHeader
                lastChecked={refreshTime}
                healthyCount={healthyStatusCount}
                degradedCount={degradedStatusCount}
                unhealthyCount={unhealthyStatusCount}
              ></HealthCheckStatusHeader>
              <div className='container pb-5'>
                <h3 className='left'>{'Services'}</h3>
                <h3 className='right'>{'Status'}</h3>
              </div>
              <div className=''>
                {healthCheckDataJson.map((account: any, i: number) => (
                  <div key={i} className='pb-4'>
                    <HealthCheckStatus
                      display={account.display}
                      apiUrl={account.apiUrl}
                      refreshTime={refreshTime}
                      handleStatusClick={handleStatusClick}
                      handleStatusSet={handleStatusSet}
                    ></HealthCheckStatus>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </HealthCheckStatusWrapper>

      <HealthCheckUnhealthyModal
        show={showUnhealthyStatusModal}
        onHide={() => {
          setShowUnhealthyStatusModal(false);
        }}
        errorMessage={unhealthyDescription}
      ></HealthCheckUnhealthyModal>
    </>
  );
};
